import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import { Form } from "react-bootstrap";
import _ from "lodash";
import "./alertDialog.scss";
import {StyledBlackButton, StyledBlueButton} from "../../styles/BootstrapStyles";

export default function AlertDialog({ isAlert, alertMessage, onClose, onConfirm, onCancel, title, toolAction }) {

  const handleClose = (type) => {
    onClose(type !== "submit" && type !== "cancel" ? "close" : type);
  };

  const stopPropagationForTab = (event) => {
    if (event.key === "Tab") {
      event.stopPropagation();
    }
  };

  return (
    <div>
      <Dialog
        open={isAlert}
        onClose={handleClose}
        onKeyDown={stopPropagationForTab}
        classes={{ scrollPaper: "alertScrollPaper", root: "alertRoot", paperScrollPaper: "paperScrollPaper" }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <label className="alertHeading">{title}</label>
        <p className="alertBody">{alertMessage}</p>
        {Boolean(toolAction) ? (
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              let noteRequest = {};
              noteRequest["note"] = e.target.notes.value;
              if (_.get(toolAction, "action") !== "QC") {
                noteRequest["notifyClient"] = e.target.notifyClient.checked;
              }
              handleClose("submit");
              if (_.isEmpty(_.get(noteRequest, "note", "").trim())) {
                e.target.notes.value = "";
              }
              onConfirm(_.get(toolAction, "value"), _.get(toolAction, "action", "status"), _.get(toolAction, "id"), noteRequest);
              e.target.notes.value = "";
              if (_.get(toolAction, "action") !== "QC") {
                e.target.notifyClient.checked = false;
              }
            }}>
            <Form.Group controlId="notes">
              <Form.Control
                as="textarea"
                required={_.get(toolAction, "comment")}
                placeholder={"Notes"}
                className="alertNote"
              />
            </Form.Group>
            {_.get(toolAction, "action") === "QC" ? null : (
              <Form.Group controlId="notifyClient">
                <Form.Check
                  style={{
                    fontSize: "14px",
                    lineHeight: "16px",
                    letterSpacing: "-0.08px",
                    color: "#333",
                    marginLeft: "30px",
                  }}
                  inline
                  type="checkbox"
                  label="Notify Client?"
                />
              </Form.Group>
            )}
            <DialogActions className="p-0">
              <StyledBlueButton
                type="submit"
                variant="contained">
                Confirm
              </StyledBlueButton>
              <StyledBlackButton
                onClick={(e) => {
                  handleClose("cancel");
                  onCancel();
                }}
                variant="contained">
                Cancel
              </StyledBlackButton>
            </DialogActions>
          </Form>
        ) : (
          <DialogActions className="p-0">
            <StyledBlueButton
              type="submit"
              onClick={(e) => {
                handleClose("submit");
                onConfirm();
              }}
              variant="contained">
              Confirm
            </StyledBlueButton>
            <StyledBlackButton
              onClick={(e) => {
                handleClose("cancel");
                onCancel();
              }}
              variant="contained">
              Cancel
            </StyledBlackButton>
          </DialogActions>
        )}
      </Dialog>
    </div>
  );
}
//Sonar fix code-smell.Using Empty functions isn't a good practice.So adding a comment inside.
AlertDialog.defaultProps = {
  onOpen: () => {/*We are sending onOpen function as a default Prop*/ },
  onClose: () => {/*We are sending onClose function as a default Prop*/ },
  onConfirm: () => {/*We are sending onConfirm function as a default Prop*/ },
  onCancel: () => {/*We are sending onCancel function as a default Prop*/ },
  isAlert: false,
  alertMessage: "",
  title: "Please Confirm",
  toolAction: null,
};
